'use client';
import Image from 'next/image';
import React, { useState } from 'react';
import animationOne from '../../animations/enterprise-software-development.json';
import animationTwo from '../../animations/mobile-app-development.json';
import animationThree from '../../animations/website-web-app-development.json';
import animationFour from '../../animations/ecommerce-development.json';
import animationFive from '../../animations/cms-development.json';
import animationSix from '../../animations/business-analysis.json';
import animationSeven from '../../animations/devops.json';
import animationEight from '../../animations/logo-braning.json';
import animationNine from '../../animations/user-experience.json';
import animationTen from '../../animations/user-interface.json';
import animationEleven from '../../animations/saas-design.json';
import animationTwelve from '../../animations/manual-testing.json';
import animationThirteen from '../../animations/automation-testing.json';
import animationForteen from '../../animations/vulnerability.json';
import animationFixteen from '../../animations/search-engine-optimization.json';
import animationSixteen from '../../animations/social-media-marketing.json';
import animationSeventeen from '../../animations/app-store-optimization.json';
import animationEighteen from '../../animations/ai-consulting-developement.json';
import animationNineteen from '../../animations/machine-learning-development.json';
import animationTwenty from '../../animations/ai-powered-web-mobile-app-development.json';
import animationTwentyone from '../../animations/natural-language-processing.json';
import Lottie from 'lottie-react';

const Navigatedigital: React.FC = () => {
    const [currentAnimation, setCurrentAnimation] = useState('0');
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = (index: any) => {
        setIsHovered(true);
        setCurrentAnimation(index);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const [activeButton, setActiveButton] = useState<number>(0);

    const buttons = [
        'Development Services',
        'Business Solutions',
        'Design & User Experience',
        'Quality & Testing',
        'Marketing & Growth',
        'AI and ML',
    ];

    const content = [
        {
            id: 'development-services', // Added id
            title: 'Development Services',
            className:
                'bg-white transition-transform duration-700 ease-in-out transform scale-100 top-[180px] sm:top-[0] lg:top-[180px]',
            items: [
                {
                    animationSrc: animationOne,
                    title: 'Enterprise Software Development',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'enterprise-software-development',
                },
                {
                    animationSrc: animationTwo,
                    title: 'Mobile App Development',
                    desc: 'High-quality mobile app solutions.',
                    type: 'json',
                    link: 'mobile-app-development',
                },
                {
                    animationSrc: animationThree,
                    title: ' Web App Development',
                    desc: 'Robust web app development services.',
                    type: 'json',
                    link: 'web-development',
                },
                {
                    animationSrc: animationFour,
                    title: 'eCommerce Development',
                    desc: 'Complete eCommerce development services.',
                    type: 'json',
                    link: 'ecommerce-development',
                },
                {
                    animationSrc: animationFive,
                    title: 'CMS Development',
                    desc: 'Custom CMS development tailored to your needs.',
                    type: 'json',
                    link: 'cms-development',
                },
            ],
        },
        {
            id: 'business-solutions', // Added id
            title: 'Business Solutions',
            className:
                'bg-white transition-transform duration-700 ease-in-out transform scale-100 top-[200px] sm:top-[0] lg:top-[200px]',
            items: [
                {
                    imgSrc: '/img/new-homepage/Simpro.svg',
                    title: 'Simpro',
                    desc: 'Experience excellence in custom software development with.',
                    type: 'image',
                    link: 'simpro-development',
                },
                {
                    imgSrc: '/img/new-homepage/odoo-bus.svg',
                    title: 'Odoo',
                    desc: 'Experience excellence in custom software development with.',
                    type: 'image',
                    link: 'odoo',
                },
                {
                    animationSrc: animationSix,
                    title: 'Business Analysis',
                    desc: 'Experience excellence in custom software development with.',
                    type: 'json',
                    link: 'business-analysis-service-baaas',
                },
                {
                    animationSrc: animationSeven,
                    title: 'DevOps',
                    desc: 'Experience excellence in custom software development with.',
                    type: 'json',
                    link: 'devops-services',
                },
            ],
        },
        {
            id: 'design-ux', // Added id
            title: 'Design & User Experience',
            className:
                'bg-white transition-transform duration-700 ease-in-out transform scale-100 top-[220px]sm:top-[0] lg:top-[220px]',
            items: [
                {
                    animationSrc: animationEight,
                    title: 'Logo & Branding',
                    desc: 'Experience excellence in custom software development with.',
                    type: 'json',
                    link: 'ui-ux-design',
                },
                {
                    animationSrc: animationNine,
                    title: 'User Experience',
                    desc: 'Experience excellence in custom software development with.',
                    type: 'json',
                    link: 'ui-ux-design',
                },
                {
                    animationSrc: animationTen,
                    title: 'User Interface',
                    desc: 'Complete eCommerce development services.',
                    type: 'json',
                    link: 'ui-ux-design',
                },
                {
                    animationSrc: animationEleven,
                    title: 'SaaS Design',
                    desc: 'Custom CMS development tailored to your needs.',
                    type: 'json',
                    link: 'ui-ux-design',
                },
            ],
        },
        {
            id: 'quality-testing', // Added id
            title: 'Quality & Testing',
            className:
                'bg-white transition-transform duration-700 ease-in-out transform scale-100 top-[240px] sm:top-[0] lg:top-[240px]',
            items: [
                {
                    animationSrc: animationTwelve,
                    title: 'Manual Testing',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'software-testing-qa-services',
                },
                {
                    animationSrc: animationThirteen,
                    title: 'Automation Testing',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'software-testing-qa-services',
                },
                {
                    animationSrc: animationForteen,
                    title: 'Vulnerability Assessment',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'software-testing-qa-services',
                },
            ],
        },
        {
            id: 'marketing-growth', // Added id
            title: 'Marketing & Growth',
            className:
                'bg-white transition-transform duration-700 ease-in-out transform scale-100 top-[260px] sm:top-[0] lg:top-[260px]',
            items: [
                {
                    animationSrc: animationFixteen,
                    title: 'Search Engine Optimization',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'digital-marketing',
                },
                {
                    animationSrc: animationSixteen,
                    title: 'Social Media Marketing ',
                    desc: 'High-quality mobile app solutions.',
                    type: 'json',
                    link: 'digital-marketing',
                },
                {
                    imgSrc: '/img/new-homepage/contentmarketing.svg',
                    title: 'Digital/Content Marketing ',
                    desc: 'Excellence in custom software development.',
                    type: 'image',
                    link: 'digital-marketing',
                },
                {
                    animationSrc: animationSeventeen,
                    title: 'App Store Optimization',
                    desc: 'Custom CMS development tailored to your needs.',
                    type: 'json',
                    link: '#',
                },
            ],
        },
        {
            id: 'ai-ml', // Added id
            title: 'AI and ML',
            className:
                'bg-white transition-transform duration-700 ease-in-out transform scale-100 top-[280px] sm:top-[0] lg:top-[260px]',
            items: [
                {
                    animationSrc: animationEighteen,
                    title: 'AI Consulting & Development',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'ai-ml-development-services',
                },
                {
                    animationSrc: animationNineteen,
                    title: 'Machine Learning Development',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'ai-ml-development-services',
                },
                {
                    animationSrc: animationTwenty,
                    title: 'AI Powered Web & Mobile Apps Development',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'ai-ml-development-services',
                },
                {
                    animationSrc: animationTwentyone,
                    title: 'Natural Language Processing',
                    desc: 'Excellence in custom software development.',
                    type: 'json',
                    link: 'ai-ml-development-services',
                },
            ],
        },
    ];

    const scrollToSection = (id: string) => {
        const sectionElement = document.getElementById(id);
        if (sectionElement) {
            const headerOffset = 80; // Adjust this based on your sticky header's height
            const elementPosition = sectionElement.getBoundingClientRect().top + window.scrollY; // Get the section's position relative to the document
            const offsetPosition = elementPosition - headerOffset;

            // Scroll to the calculated position
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <section className="Development-Services section-py  bg-para_gray navigate-section-spacing">
            <div className="container lg:container md:mx-auto">
                <div className="pb-10 grid grid-cols-12">
                    <h2 className="text-5xl font-bold leading-[64px] sm:text-2xl sm:leading-[32px] md:text-5xl md:leading-[64px] col-span-9 pb-[15px]">
                        Navigate the Digital Frontier with Our Engineering Excellence
                    </h2>
                    <p className="col-span-10 text-textcolor mb-0">
                        Our cutting-edge digital solutions and services have been helping businesses across the world to mitigate
                        modern business challenges with a modern digital-first approach.
                    </p>
                </div>

                <div className="button-wrap flex flex-wrap text-secondary justify-start border-b border-b-[#3C45614D] sticky  sm:relative lg:sticky top-[80px] z-20 bg-para_gray mb-50 sm:mb-0 lg:mb-50 sm:hidden lg:flex">
                    {buttons.map((label, idx) => (
                        <button
                            key={label}
                            className={`inline-block p-5 text-center text-border_new font-semibold text-[17px] leading-[25px] ${
                                activeButton === idx ? 'font-bold border-b-[3px] border-b-textcolor text-textcolor' : ''
                            }`}
                            onClick={() => {
                                scrollToSection(content[idx].id); // Updated to use id
                                setActiveButton(idx);
                            }}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                <div className="flex flex-col gap-5 ">
                    {content.map((section, idx) => (
                        <div
                            key={idx}
                            id={section.id} // Added id attribute
                            className={`p-10 sm:p-[20px] lg:p-10 sticky sm:relative lg:sticky rounded-10 border border-para_gray ${section.className}`}
                        >
                            <h3 className="lg:text-4xl lg:leading-[50px] sm:text-xl sm:leading-[26px] md:text-xl md:leading-[26px] text-textcolor pb-[30px]">
                                {section.title}
                            </h3>
                            <div className="flex sm:flex-col lg:flex-row lg:gap-5 md:gap-8 gap-8 items-stretch">
                                {section.items.map((item: any, itemIdx) => (
                                    <div
                                        onMouseEnter={() => handleMouseEnter(itemIdx + '-' + idx)}
                                        onMouseLeave={handleMouseLeave}
                                        key={itemIdx}
                                        className="flex flex1 flex-col justify-between gap-[15px] w-[360px] sm:w-full lg:w-[360px] relative"
                                    >
                                        <div className="flex sm:flex-row lg:flex-col gap-[15px]">
                                            <div>
                                                {item.type == 'image' && (
                                                    <Image
                                                        className="bg-[#05A6F01A] p-3.5 rounded-md"
                                                        src={item.imgSrc || '/img/default-image.svg'} // Default image if imgSrc is missing
                                                        alt={item.title}
                                                        width={66}
                                                        height={66}
                                                    />
                                                )}
                                                {item.type == 'json' && (
                                                    <div>
                                                        <Lottie
                                                            animationData={item.animationSrc}
                                                            // autoplay={isHovered && currentAnimation === itemIdx + '-' + idx}
                                                            loop={isHovered && currentAnimation === itemIdx + '-' + idx}
                                                            style={{ width: 66, height: 66 }}
                                                            className="bg-[#05A6F01A] p-2 rounded-md"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <div className="mb-8">
                                                    <h4 className="text-xl leading-[26px] font-bold text-textcolor pb-[5px]">
                                                        {item.title}
                                                    </h4>
                                                    <p className="text-[17px] leading-[25px] text-border_new mb-0">{item.desc}</p>
                                                </div>
                                                <div>
                                                    <a className="flex items-center absolute bottom-0" href={item.link}>
                                                        <p className="text-primary text-[17px] leading-[25px] font-semibold mb-0">
                                                            Learn More
                                                        </p>
                                                        <Image
                                                            className="mt-1 ml-1"
                                                            src="/img/new-homepage/aero-right.svg"
                                                            alt="Arrow Icon"
                                                            width={10}
                                                            height={15}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Navigatedigital;
